import { useEffect, useState } from 'react';
import Navigation from '../product/components/Navigation';
import Footer from '../product/components/Footer';

export default function ProductWakasa4() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const products = [
    {
      id: 1,
      mainImage: 'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/8d845c906cfb5c285dacbddc302bd7f6.png',
      images: [
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/047c6f91e07df722dcdfa8dab7592c5a.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/b4059312112118951bf8fe16d42cbc5f.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/cbea989c4e5dd09ddf7e83315687e1e8.png'
      ],
      name: '01 L9000'
    },
    {
      id: 2,
      mainImage: 'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/e48297aecf3f5b8aec54f018b1ce3b72.png',
      images: [
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/7dfd9002fd6aac1241021450a58be3a1.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/e0b3b65c96b99a080906a5c04a7fc862.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/8d76a4545e7dd17aaeb0abef07cf5ebb.png'
      ],
      name: '02 A87048T'
    },
    {
      id: 3,
      mainImage: 'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/8261d303aac0f608d9aefc2fec90ca6d.png',
      images: [
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/17e1c39dd72ed0aa149b15ce5b3c1bc5.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/0808511516af24366eb15feed886eef8.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/6947912d755992e5650311a48fe549ca.png'
      ],
      name: '03 C83003T マット'
    },
    {
      id: 4,
      mainImage: 'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/700dd0d606b5222ff4f073e9d0c4e1c9.png',
      images: [
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/b93c54f73d3f50af15628f4cd92cddcb.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/1fb8602099af0024f98f51037647a93c.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/7d51c4d1ca5c1f7b056b3d8a7f74259c.png'
      ],
      name: '04 GX5-013'
    },
    {
      id: 5,
      mainImage: 'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/2f4e7d624a955c1872631fbc7bcf5c59.png',
      images: [
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/b3e43144b37bf7511138f5a708d64a69.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/38406294706403fed42d158479b5ca98.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/497ee2f2bd6d669d5c22de2b77719e41.png'
      ],
      name: '05 B62003T マット'
    },
    {
      id: 6,
      mainImage: 'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/97b7c08b589bc83b22b4b4bc48b3c84f.png',
      images: [
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/7263400899fcad778168879d87bf9012.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/a46325709cb4d7b5b0314d5f6eb21fff.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/e25a0cb204a7ec21a8a2495912e41f80.png'
      ],
      name: '06 B62001T'
    }
  ];

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Navigation scrolled={scrolled} />
      
      <main className="pt-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12">
          {/* Breadcrumb */}
          <div className="mb-8">
            <nav className="flex items-center space-x-2 text-sm text-gray-600">
              <a href="/" className="hover:text-gray-900 transition-colors cursor-pointer">
                トップページ
              </a>
              <span>&gt;</span>
              <a href="https://www.1994real.com/catalog.html" target="_blank" rel="noopener noreferrer" className="hover:text-gray-900 transition-colors cursor-pointer">
                カタログ
              </a>
              <span>&gt;</span>
              <span className="text-gray-900">温故知新 若狭 四 全6色 6(colors)</span>
            </nav>
          </div>

          {/* Product Header */}
          <div className="mb-12">
            <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6">
              <div>
                <h1 className="font-['Noto_Serif_JP'] text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
                  温故知新 若狭 四 全6色 6(colors)
                </h1>
              </div>
              <div className="bg-gray-50 rounded-lg p-6 lg:min-w-[300px]">
                <table className="w-full text-sm">
                  <tbody>
                    <tr className="border-b border-gray-200">
                      <th className="text-left py-3 pr-4 font-medium text-gray-700">frame</th>
                      <td className="py-3 text-gray-900">48□23-143</td>
                    </tr>
                    <tr>
                      <th className="text-left py-3 pr-4 font-medium text-gray-700">希望小売価格</th>
                      <td className="py-3 text-gray-900 font-bold">129,800円(税込)</td>
                    </tr>
                  </tbody>
                </table>
                <p className="text-xs text-gray-600 mt-4">
                  写真をクリックすると拡大してご覧になれます<br />
                  詳細は<a href="https://ameblo.jp/real-inouefumihide/" target="_blank" rel="noopener noreferrer" className="text-gray-900 underline hover:text-gray-600 cursor-pointer">ブログ</a>にて紹介しています
                </p>
              </div>
            </div>
          </div>

          {/* Product Gallery */}
          <div className="space-y-16">
            {products.map((product) => (
              <div key={product.id} className="border-b border-gray-200 pb-16 last:border-b-0">
                {/* Main Image */}
                <div className="mb-8">
                  <div className="relative w-full px-8 md:px-16 lg:px-24">
                    <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
                      <div className="aspect-[4/3] flex items-center justify-center p-8 md:p-12">
                        <img
                          src={product.mainImage}
                          alt={product.name}
                          className="max-w-full max-h-full object-contain cursor-pointer hover:scale-105 transition-transform duration-500"
                          onClick={() => window.open(product.mainImage, '_blank')}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Thumbnail Images */}
                <div className="grid grid-cols-3 gap-4">
                  {product.images.map((image, index) => (
                    <div key={index} className="text-center">
                      <div className="w-full h-[300px] bg-gray-100 rounded-lg overflow-hidden mb-2">
                        <img
                          src={image}
                          alt={`${product.name} - ${index + 1}`}
                          className="w-full h-full object-cover cursor-pointer hover:opacity-80 transition-opacity"
                          onClick={() => window.open(image, '_blank')}
                        />
                      </div>
                      <p className="text-sm text-gray-700">{product.name}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Back to Catalog Button */}
          <div className="mt-12 text-center">
            <a
              href="https://real1994.official.ec/categories/4659620"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-gray-900 text-white px-8 py-3 rounded-full text-sm font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              ONLINE STORE
            </a>
          </div>
        </div>

        {/* Page Top Button */}
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 w-12 h-12 bg-gray-900 text-white rounded-full flex items-center justify-center hover:bg-gray-800 transition-colors shadow-lg cursor-pointer z-40"
        >
          <i className="ri-arrow-up-line text-xl"></i>
        </button>
      </main>

      <Footer />
    </div>
  );
}
